import { fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { createApiTracker } from "../../analytics/utils/apiTracker";

const LOGOUT_IN_PROGRESS_STATUS = "LOGOUT_IN_PROGRESS";

const shouldSkipRequestDuringLogout = (state) =>
  Boolean(state?.loaderReducer?.logoutLoading);

export const createBaseQueryWithLogoutGuard = (options = {}) => {
  const rawBaseQuery = fetchBaseQuery(options);
  const tracker = createApiTracker();

  return async (args, api, extraOptions) => {
    if (shouldSkipRequestDuringLogout(api?.getState?.())) {
      return {
        error: {
          status: LOGOUT_IN_PROGRESS_STATUS,
          data: {
            message: "Request skipped during logout",
            error: LOGOUT_IN_PROGRESS_STATUS,
          },
        },
      };
    }

    const config = {
      method: typeof args === "string" ? "GET" : args?.method || "GET",
      metadata: { apiName: api?.endpoint },
    };
    config.metadata = tracker.onRequest(config).metadata;
    let result;
    try {
      result = await rawBaseQuery(args, api, extraOptions);
    } catch (error) {
      tracker.onResponse({ config, ok: false });
      throw error;
    }
    const errorStatus = result?.error?.status;
    tracker.onResponse({
      config,
      status:
        result?.meta?.response?.status ||
        (typeof errorStatus === "number" ? errorStatus : result?.error?.originalStatus),
      ok: !result?.error,
      data: result?.error?.data || result?.data,
    });
    return result;
  };
};
